// import React, { useState, useEffect } from 'react';
// import { useParams } from 'react-router-dom';
// import {
//   Card,Box,
//   CardHeader,
//   CardContent,
//   Grid,
//   Typography,
//   Avatar,
//   IconButton,
//   Divider,
//   Chip,
//   TextField,
//   InputAdornment,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TablePagination,
//   TableRow,
//   Paper,
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   CircularProgress,
//   Badge,
//   Tabs,
//   Tab,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Collapse
// } from '@mui/material';

// import {ModernCard, PrimaryButton, SecondaryButton} from '../components/MiniComponent/Common';
// import axios, { renderDoc, decryptData } from '../Axiosinstance';
// import './Manage.css';

// import {
//   Search,
//   Alert,
//   Close,
//   ExpandMore,
//   ExpandLess,
//   Person,
//   Email,
//   Phone,
//   Fingerprint,
//   CalendarToday,
//   School,
//   Work,
//   Emergency,
//   Description,
//   Payment,
//   Schedule,
//   LocationOn,
//   Link,
//   Visibility,
//   ArrowBack,
//   MoreVert,
//   // Add these missing icons:
//   Wc as WcIcon,
//   Public as PublicIcon,
//   TempleBuddhist as TempleBuddhistIcon,
//   HowToReg as HowToRegIcon,
//   AirplanemodeActive as AirplanemodeActiveIcon,
//   EventAvailable as EventAvailableIcon,
//   Home as HomeIcon,
//   LocalPostOffice as LocalPostOfficeIcon
// } from '@mui/icons-material';

// import {  deepPurple, teal, amber } from '@mui/material/colors';



// const Green = () => {
//   const { batchId, intakeId } = useParams();
//   const batchId1 = decryptData(decodeURIComponent(batchId));
//   const intakeId1 = decryptData(decodeURIComponent(intakeId));
//   const [showModal, setShowModal] = useState(false);
//   const [selectedStudentData, setSelectedStudentData] = useState(null);
//   const [students, setStudents] = useState([]);
//   const [externalStudents, setExternalStudents] = useState([]);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchExternalData = async () => {
//       try {
//         setLoading(true);
//         const response = await axios.get(`/registrationadvances/active/${intakeId1}`);
//         setExternalStudents(response.data);
//       } catch (err) {
//         console.error('Error fetching external data:', err);
//         setError('Failed to load student data. Please try again later.');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchExternalData();
//   }, [intakeId1]);

//   const handleView = async (studentId) => {
//     try {
//       setLoading(true);
//       const response = await axios.get(`/registrationadvances/${studentId}`);
//       setSelectedStudentData(response.data);
//       setShowModal(true);
//     } catch (err) {
//       console.error('Error fetching student data:', err);
//       setError('Failed to load student details. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleCloseModal = () => {
//     setShowModal(false);
//     setSelectedStudentData(null);
//   };

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   const filteredStudents = externalStudents.filter(student =>
//     student.name?.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   const paginatedStudents = filteredStudents.slice(
//     page * rowsPerPage,
//     page * rowsPerPage + rowsPerPage
//   );

//   if (error) {
//     return (
//       <div severity="error" sx={{ m: 2 }}>
//         {error}
//       </div>
//     );
//   }

// return (
//     <Grid container spacing={3} sx={{ p: 3 }}>
//       {/* Search Bar */}
//       <Grid item xs={12}>
//         <ModernCard>
//           <CardContent>
//             <TextField
//               fullWidth
//               variant="outlined"
//               placeholder="Search students..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <Search />
//                   </InputAdornment>
//                 ),
//                 sx: { borderRadius: '12px' }
//               }}
//             />
//           </CardContent>
//         </ModernCard>
//       </Grid>

//       {/* Students Table */}
//       <Grid item xs={12}>
//         <ModernCard>
//           <CardHeader
//             title="Students List"
//             action={
//               <Chip 
//                 label={`${filteredStudents.length} students`}
//                 color="primary"
//                 variant="outlined"
//               />
//             }
//           />
//           <Divider />
//           <TableContainer>
//             <Table>
//               <TableHead>
//                 <TableRow sx={{ bgcolor: 'background.default' }}>
//                   <TableCell sx={{ fontWeight: 700 }}>Student</TableCell>
//                   <TableCell sx={{ fontWeight: 700 }}>Contact</TableCell>
//                   <TableCell sx={{ fontWeight: 700 }}>Intake</TableCell>
//                   <TableCell sx={{ fontWeight: 700 }}>Enrollment</TableCell>
//                   <TableCell sx={{ fontWeight: 700 }}>Actions</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {paginatedStudents.map((student) => (
//                   <TableRow hover key={student.id}>
//                     <TableCell>
//                       <Box display="flex" alignItems="center" gap={2}>
//                         <Avatar src={student.profileUrl} />
//                         <Box>
//                           <Typography fontWeight={600}>{student.name}</Typography>
//                           <Typography variant="body2" color="text.secondary">
//                             {student.nric ? `••••${student.nric.slice(-4)}` : 'N/A'}
//                           </Typography>
//                         </Box>
//                       </Box>
//                     </TableCell>
//                     <TableCell>
//                       <Typography>{student.email}</Typography>
//                       <Typography variant="body2" color="text.secondary">
//                         {student.phone}
//                       </Typography>
//                     </TableCell>
//                     <TableCell>
//                       <Chip 
//                         label={student.intakeId} 
//                         color="primary" 
//                         size="small"
//                         variant="outlined"
//                       />
//                     </TableCell>
//                     <TableCell>
//                       {new Date(student.enrolledDate).toLocaleDateString('en-GB')}
//                     </TableCell>
//                     <TableCell>
//                       <SecondaryButton
//                         size="small"
//                         startIcon={<Visibility />}
//                         onClick={() => handleView(student.id)}
//                       >
//                         View
//                       </SecondaryButton>
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//           <TablePagination
//             rowsPerPageOptions={[5, 10, 25]}
//             component="div"
//             count={filteredStudents.length}
//             rowsPerPage={rowsPerPage}
//             page={page}
//             onPageChange={handleChangePage}
//             onRowsPerPageChange={handleChangeRowsPerPage}
//           />
//         </ModernCard>
//       </Grid>

//       {/* Student Details Modal */}
//       {showModal && (
//         <StudentDetailsModal
//           open={showModal}
//           onClose={handleCloseModal}
//           studentData={selectedStudentData}
//           loading={loading}
//         />
//       )}
//     </Grid>
//   );
// };

// // Optimized StudentDetailsModal Component
// const StudentDetailsModal = ({ open, onClose, studentData, loading }) => {
//   const [expandedSection, setExpandedSection] = useState('personal');

//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     return new Date(dateString).toLocaleDateString('en-GB');
//   };

//   const handleSectionChange = (section) => {
//     setExpandedSection(section);
//   };

//   // Helper component for consistent info display
//   const InfoRow = ({ label, value, icon }) => (
//     <Grid item xs={12} sm={6}>
//       <Box display="flex" alignItems="center" gap={1} mb={1}>
//         {icon && React.cloneElement(icon, { color: 'primary', fontSize: 'small' })}
//         <Typography variant="body2" fontWeight="bold" minWidth={120}>
//           {label}:
//         </Typography>
//         <Typography variant="body2">
//           {value || 'N/A'}
//         </Typography>
//       </Box>
//     </Grid>
//   );

//   return (
//     <Dialog
//       fullScreen
//       open={open}
//       onClose={onClose}
//       PaperProps={{
//         sx: {
//           background: 'linear-gradient(120deg, #f6f9fc, #ffffff)'
//         }
//       }}
//     >
//       <DialogTitle sx={{ borderBottom: '1px solid rgba(0,0,0,0.08)' }}>
//         <Box display="flex" justifyContent="space-between" alignItems="center">
//           <Box display="flex" alignItems="center" gap={2}>
//             <IconButton onClick={onClose}>
//               <ArrowBack />
//             </IconButton>
//             <Typography variant="h5" fontWeight={700}>
//               {studentData?.name}'s Profile
//             </Typography>
//           </Box>
//           <Chip 
//             label={studentData?.status || 'N/A'} 
//             color={studentData?.status === 'Active' ? 'success' : 'default'}
//           />
//         </Box>
//       </DialogTitle>

//       <DialogContent>
//         {loading ? (
//           <Box display="flex" justifyContent="center" py={10}>
//             <CircularProgress />
//           </Box>
//         ) : (
//           <Grid container spacing={3} sx={{ pt: 2 }}>
//             {/* Left Side - Profile Card */}
//             <Grid item xs={12} md={4}>
//               <ModernCard>
//                 <Box display="flex" flexDirection="column" alignItems="center" p={3}>
//                   <Badge
//                     overlap="circular"
//                     anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
//                     badgeContent={
//                       <Chip 
//                         label={studentData?.status || 'N/A'}
//                         size="small" 
//                         color={studentData?.status === 'Active' ? 'success' : 'default'}
//                         sx={{ 
//                           color: 'white',
//                           fontWeight: 600,
//                           fontSize: '0.65rem'
//                         }}
//                       />
//                     }
//                   >
//                     <Avatar
//                       src={studentData?.profileUrl}
//                       sx={{
//                         width: 120,
//                         height: 120,
//                         border: `4px solid ${deepPurple[100]}`
//                       }}
//                     />
//                   </Badge>
//                   <Typography variant="h6" mt={2} fontWeight={700}>
//                     {studentData?.name}
//                   </Typography>
//                   <Typography color="text.secondary">
//                     {studentData?.course}
//                   </Typography>
//                   <Chip
//                     label={`Intake: ${studentData?.intakeId}`}
//                     color="primary"
//                     size="small"
//                     sx={{ mt: 1 }}
//                   />
//                 </Box>

//                 <Divider />

//                 <List>
//                   <ListItem>
//                     <ListItemIcon>
//                       <Email color="primary" />
//                     </ListItemIcon>
//                     <ListItemText
//                       primary="Email"
//                       secondary={studentData?.email || 'N/A'}
//                     />
//                   </ListItem>
//                   <ListItem>
//                     <ListItemIcon>
//                       <Phone color="primary" />
//                     </ListItemIcon>
//                     <ListItemText
//                       primary="Phone"
//                       secondary={studentData?.phone || 'N/A'}
//                     />
//                   </ListItem>
//                   <ListItem>
//                     <ListItemIcon>
//                       <Fingerprint color="primary" />
//                     </ListItemIcon>
//                     <ListItemText
//                       primary="NRIC"
//                       secondary={studentData?.nric ? `••••${studentData.nric.slice(-4)}` : 'N/A'}
//                     />
//                   </ListItem>
//                   <ListItem>
//                     <ListItemIcon>
//                       <CalendarToday color="primary" />
//                     </ListItemIcon>
//                     <ListItemText
//                       primary="Enrolled"
//                       secondary={formatDate(studentData?.enrolledDate)}
//                     />
//                   </ListItem>
//                 </List>
//               </ModernCard>

//               {/* Documents Card */}
//               <ModernCard sx={{ mt: 3 }}>
//                 <CardHeader title="Documents" />
//                 <CardContent>
//                   <List>
//                     {studentData?.nricdoc && (
//                       <ListItem>
//                         <ListItemIcon>
//                           <Description color="primary" />
//                         </ListItemIcon>
//                         <ListItemText primary="NRIC Document" />
//                         <Button 
//                           size="small" 
//                           onClick={() => window.open(studentData.nricdoc, '_blank')}
//                         >
//                           View
//                         </Button>
//                       </ListItem>
//                     )}
//                     {studentData?.passportdoc && (
//                       <ListItem>
//                         <ListItemIcon>
//                           <Description color="primary" />
//                         </ListItemIcon>
//                         <ListItemText primary="Passport Document" />
//                         <Button 
//                           size="small" 
//                           onClick={() => window.open(studentData.passportdoc, '_blank')}
//                         >
//                           View
//                         </Button>
//                       </ListItem>
//                     )}
//                     {studentData?.educationdoc && (
//                       <ListItem>
//                         <ListItemIcon>
//                           <Description color="primary" />
//                         </ListItemIcon>
//                         <ListItemText primary="Education Document" />
//                         <Button 
//                           size="small" 
//                           onClick={() => window.open(studentData.educationdoc, '_blank')}
//                         >
//                           View
//                         </Button>
//                       </ListItem>
//                     )}
//                   </List>
//                 </CardContent>
//               </ModernCard>
//             </Grid>

//             {/* Right Side - Details */}
//             <Grid item xs={12} md={8}>
//               <Tabs
//                 value={expandedSection}
//                 onChange={(e, newValue) => handleSectionChange(newValue)}
//                 variant="scrollable"
//                 scrollButtons="auto"
//                 sx={{ mb: 2 }}
//               >
//                 <Tab label="Personal" value="personal" icon={<Person />} />
//                 <Tab label="Education" value="education" icon={<School />} />
//                 <Tab label="Work" value="work" icon={<Work />} />
//                 <Tab label="Schedule" value="schedule" icon={<Schedule />} />
//                 <Tab label="Financial" value="financial" icon={<Payment />} />
//               </Tabs>

//               {/* Personal Info Section */}
//               <Collapse in={expandedSection === 'personal'}>
//                 <ModernCard sx={{ mb: 3 }}>
//                   <CardHeader title="Personal Information" />
//                   <CardContent>
//                     <Grid container spacing={2}>
//                       <InfoRow label="Full Name" value={studentData?.name} icon={<Person />} />
//                       <InfoRow label="Gender" value={studentData?.gender} icon={<WcIcon />} />
//                       <InfoRow label="Date of Birth" value={formatDate(studentData?.dob)} icon={<CalendarToday />} />
//                       <InfoRow label="Citizenship" value={studentData?.citizenship} icon={<PublicIcon />} />
//                       <InfoRow label="Religion" value={studentData?.religion} icon={<TempleBuddhistIcon />} />
//                       <InfoRow label="Marital Status" value={studentData?.maritalStatus} icon={<HowToRegIcon />} />
//                       <InfoRow label="Passport" value={studentData?.passport} icon={<AirplanemodeActiveIcon />} />
//                       <InfoRow label="Passport Expiry" value={formatDate(studentData?.passportExpiryDate)} icon={<EventAvailableIcon />} />
//                       <InfoRow label="SG Address" value={studentData?.currentAddress} icon={<LocationOn />} />
//                       <InfoRow label="Home Address" value={studentData?.address} icon={<HomeIcon />} />
//                       <InfoRow label="Postal Code" value={studentData?.postalcode} icon={<LocalPostOfficeIcon />} />
//                     </Grid>
//                   </CardContent>
//                 </ModernCard>

//                 {/* Emergency Contacts */}
//                 <ModernCard sx={{ mb: 3 }}>
//                   <CardHeader title="Emergency Contacts" />
//                   <CardContent>
//                     {studentData?.emergencyContacts?.length > 0 ? (
//                       studentData.emergencyContacts.map((contact, index) => (
//                         <Box key={index} mb={2}>
//                           <Typography variant="subtitle1" fontWeight="bold">
//                             {contact.relationship}
//                           </Typography>
//                           <Grid container spacing={2}>
//                             <InfoRow label="Name" value={contact.name} />
//                             <InfoRow label="Phone" value={contact.number} />
//                           </Grid>
//                         </Box>
//                       ))
//                     ) : (
//                       <Typography variant="body2" color="text.secondary">
//                         No emergency contacts available
//                       </Typography>
//                     )}
//                   </CardContent>
//                 </ModernCard>
//               </Collapse>

//               {/* Education Section */}
//               <Collapse in={expandedSection === 'education'}>
//                 <ModernCard sx={{ mb: 3 }}>
//                   <CardHeader title="Education History" />
//                   <CardContent>
//                     {studentData?.institutionDetails?.length > 0 ? (
//                       studentData.institutionDetails.map((institution, index) => (
//                         <Box key={index} mb={3}>
//                           <Box display="flex" justifyContent="space-between" mb={1}>
//                             <Typography variant="subtitle1" fontWeight="bold">
//                               {institution.institution}
//                             </Typography>
//                             {institution.highest && (
//                               <Chip label="Highest Qualification" size="small" color="primary" />
//                             )}
//                           </Box>
//                           <Grid container spacing={2}>
//                             <InfoRow label="Qualification" value={institution.qualificationsAchieved} />
//                             <InfoRow label="Years" value={`${institution.fromYear} - ${institution.toYear}`} />
//                             <InfoRow label="Country" value={institution.country} />
//                             <InfoRow label="Language" value={institution.language} />
//                           </Grid>
//                         </Box>
//                       ))
//                     ) : (
//                       <Typography variant="body2" color="text.secondary">
//                         No education history available
//                       </Typography>
//                     )}
//                   </CardContent>
//                 </ModernCard>
//               </Collapse>

//               {/* Work Experience Section */}
//               <Collapse in={expandedSection === 'work'}>
//                 <ModernCard sx={{ mb: 3 }}>
//                   <CardHeader title="Work Experience" />
//                   <CardContent>
//                     {studentData?.workExpirences?.length > 0 ? (
//                       studentData.workExpirences.map((work, index) => (
//                         <Box key={index} mb={3}>
//                           <Typography variant="subtitle1" fontWeight="bold">
//                             {work.name}
//                           </Typography>
//                           <Grid container spacing={2}>
//                             <InfoRow label="Position" value={work.position} />
//                             <InfoRow label="Years" value={`${work.fromYear} - ${work.toYear}`} />
//                             <InfoRow label="Country" value={work.country} />
//                             <InfoRow label="Nature of Position" value={work.natureOfPosition} />
//                           </Grid>
//                         </Box>
//                       ))
//                     ) : (
//                       <Typography variant="body2" color="text.secondary">
//                         No work experience available
//                       </Typography>
//                     )}
//                   </CardContent>
//                 </ModernCard>
//               </Collapse>

//               {/* Schedule Section */}
//               <Collapse in={expandedSection === 'schedule'}>
//                 <ModernCard sx={{ mb: 3 }}>
//                   <CardHeader title="Module Schedule" />
//                   <CardContent>
//                     {studentData?.scheduleDate?.length > 0 ? (
//                       <Grid container spacing={2}>
//                         {studentData.scheduleDate.map((schedule, index) => {
//                           const module = studentData.batch?.moduleDetails?.find(
//                             m => m.id === schedule.startModulus
//                           );
//                           return (
//                             <Grid item xs={12} sm={6} key={index}>
//                               <ModernCard sx={{ p: 2 }}>
//                                 <Typography variant="subtitle2" fontWeight="bold">
//                                   {module?.moduleName || `Module ${schedule.startModulus}`}
//                                 </Typography>
//                                 <InfoRow label="Start Date" value={formatDate(schedule.startDate)} />
//                                 <InfoRow label="End Date" value={formatDate(schedule.endDate)} />
//                               </ModernCard>
//                             </Grid>
//                           );
//                         })}
//                       </Grid>
//                     ) : (
//                       <Typography variant="body2" color="text.secondary">
//                         No schedule available
//                       </Typography>
//                     )}
//                   </CardContent>
//                 </ModernCard>
//               </Collapse>

//               {/* Financial Section */}
//               <Collapse in={expandedSection === 'financial'}>
//                 <ModernCard sx={{ mb: 3 }}>
//                   <CardHeader title="Financial Information" />
//                   <CardContent>
//                     <Grid container spacing={2}>
//                       <InfoRow label="Course Fee" value={`$${studentData?.courseFee}`} />
//                       <InfoRow label="Registration Fee" value={`$${studentData?.registrationFee}`} />
//                       <InfoRow label="Discount Amount" value={`$${studentData?.discountAmount || '0'}`} />
//                     </Grid>

//                     <Typography variant="h6" mt={3} mb={2}>
//                       Installment Schedule
//                     </Typography>
//                     {studentData?.installmentDue?.length > 0 ? (
//                       <Grid container spacing={2}>
//                         {studentData.installmentDue.map((installment, index) => (
//                           <Grid item xs={12} sm={6} key={index}>
//                             <ModernCard sx={{ p: 2 }}>
//                               <Box display="flex" justifyContent="space-between">
//                                 <Typography variant="subtitle2" fontWeight="bold">
//                                   Installment #{installment.installmentNo}
//                                 </Typography>
//                                 <Chip label={`$${installment.amount}`} color="primary" size="small" />
//                               </Box>
//                               <InfoRow label="Due Date" value={formatDate(installment.dateDue)} />
//                             </ModernCard>
//                           </Grid>
//                         ))}
//                       </Grid>
//                     ) : (
//                       <Typography variant="body2" color="text.secondary">
//                         No installment schedule available
//                       </Typography>
//                     )}
//                   </CardContent>
//                 </ModernCard>
//               </Collapse>
//             </Grid>
//           </Grid>
//         )}
//       </DialogContent>

//       <DialogActions sx={{ p: 2, borderTop: '1px solid rgba(0,0,0,0.08)' }}>
//         <SecondaryButton onClick={onClose}>
//           Close
//         </SecondaryButton>
//         {/* <PrimaryButton>
//           Save Changes
//         </PrimaryButton> */}
//       </DialogActions>
//     </Dialog>
//   );
// };
// export default Green;

import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  Card,Box,
  CardHeader,
  CardContent,
  Grid,
  Typography,
  Avatar,
  IconButton,
  Divider,
  Chip,
  TextField,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  Badge,
  Tabs,
  Tab,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse
} from '@mui/material';

import {ModernCard, PrimaryButton, SecondaryButton} from '../components/MiniComponent/Common';
import axios, { renderDoc, decryptData } from '../Axiosinstance';
import './Manage.css';

import {
  Search,
  Alert,
  Close,
  ExpandMore,
  ExpandLess,
  Person,
  Email,
  Phone,
  Fingerprint,
  CalendarToday,
  School,
  Work,
  Emergency,
  Description,
  Payment,
  Schedule,
  LocationOn,
  Link,
  Visibility,
  ArrowBack,
  MoreVert,
  // Add these missing icons:
  Wc as WcIcon,
  Public as PublicIcon,
  TempleBuddhist as TempleBuddhistIcon,
  HowToReg as HowToRegIcon,
  AirplanemodeActive as AirplanemodeActiveIcon,
  EventAvailable as EventAvailableIcon,
  Home as HomeIcon,
  LocalPostOffice as LocalPostOfficeIcon
} from '@mui/icons-material';

import {  deepPurple, teal, amber } from '@mui/material/colors';



const Green = () => {
  const { batchId, intakeId } = useParams();
  const batchId1 = decryptData(decodeURIComponent(batchId));
  const intakeId1 = decryptData(decodeURIComponent(intakeId));
  const [showModal, setShowModal] = useState(false);
  const [selectedStudentData, setSelectedStudentData] = useState(null);
  const [students, setStudents] = useState([]);
  const [externalStudents, setExternalStudents] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchExternalData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`/registrationadvances/active/${intakeId1}`);
        setExternalStudents(response.data);
      } catch (err) {
        console.error('Error fetching external data:', err);
        setError('Failed to load student data. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchExternalData();
  }, [intakeId1]);

  const handleView = async (studentId) => {
    try {
      setLoading(true);
      const response = await axios.get(`/registrationadvances/${studentId}`);
      setSelectedStudentData(response.data);
      setShowModal(true);
    } catch (err) {
      console.error('Error fetching student data:', err);
      setError('Failed to load student details. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedStudentData(null);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const filteredStudents = externalStudents.filter(student =>
    student.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const paginatedStudents = filteredStudents.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  if (error) {
    return (
      <div severity="error" sx={{ m: 2 }}>
        {error}
      </div>
    );
  }

return (
    <Grid container spacing={3} sx={{ p: 3 }}>
      {/* Search Bar */}
      <Grid item xs={12}>
        <ModernCard>
          <CardContent>
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Search students..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
                sx: { borderRadius: '12px' }
              }}
            />
          </CardContent>
        </ModernCard>
      </Grid>

      {/* Students Table */}
      <Grid item xs={12}>
        <ModernCard>
          <CardHeader
            title="Students List"
            action={
              <Chip 
                label={`${filteredStudents.length} students`}
                color="primary"
                variant="outlined"
              />
            }
          />
          <Divider />
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow sx={{ bgcolor: 'background.default' }}>
                  <TableCell sx={{ fontWeight: 700 }}>Student</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Contact</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Intake</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Enrollment</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedStudents.map((student) => (
                  <TableRow hover key={student.id}>
                    <TableCell>
                      <Box display="flex" alignItems="center" gap={2}>
                        <Avatar src={student.profileUrl} />
                        
                        <Box>
                          <Typography fontWeight={600}>{student.name}</Typography>
                          <Typography variant="body2" color="text.secondary">
                            {student.nric ? `••••${student.nric.slice(-4)}` : 'N/A'}
                          </Typography>
                        </Box>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Typography>{student.email}</Typography>
                      <Typography variant="body2" color="text.secondary">
                        {student.phone}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Chip 
                        label={student.intakeId} 
                        color="primary" 
                        size="small"
                        variant="outlined"
                      />
                    </TableCell>
                    <TableCell>
                      {new Date(student.enrolledDate).toLocaleDateString('en-GB')}
                    </TableCell>
                    <TableCell>
                      <SecondaryButton
                        size="small"
                        startIcon={<Visibility />}
                        onClick={() => handleView(student.id)}
                      >
                        View
                      </SecondaryButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredStudents.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </ModernCard>
      </Grid>

      {/* Student Details Modal */}
      {showModal && (
        <StudentDetailsModal
          open={showModal}
          onClose={handleCloseModal}
          studentData={selectedStudentData}
          loading={loading}
        />
      )}
    </Grid>
  );
};

// Optimized StudentDetailsModal Component
// const StudentDetailsModal = ({ open, onClose, studentData, loading }) => {
  export const StudentDetailsModal = ({ open, onClose, studentData, loading }) => {

  const [expandedSection, setExpandedSection] = useState('personal');

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-GB');
  };

  const handleSectionChange = (section) => {
    setExpandedSection(section);
  };

  // Helper component for consistent info display
  const InfoRow = ({ label, value, icon }) => (
    <Grid item xs={12} sm={6}>
      <Box display="flex" alignItems="center" gap={1} mb={1}>
        {icon && React.cloneElement(icon, { color: 'primary', fontSize: 'small' })}
        <Typography variant="body2" fontWeight="bold" minWidth={120}>
          {label}:
        </Typography>
        <Typography variant="body2">
          {value || 'N/A'}
        </Typography>
      </Box>
    </Grid>
  );

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          background: 'linear-gradient(120deg, #f6f9fc, #ffffff)'
        }
      }}
    >
      <DialogTitle sx={{ borderBottom: '1px solid rgba(0,0,0,0.08)' }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box display="flex" alignItems="center" gap={2}>
            <IconButton onClick={onClose}>
              <ArrowBack />
            </IconButton>
            <Typography variant="h5" fontWeight={700}>
              {studentData?.name}'s Profile
            </Typography>
          </Box>
          <Chip 
            label={studentData?.status || 'N/A'} 
            color={studentData?.status === 'Active' ? 'success' : 'default'}
          />
        </Box>
      </DialogTitle>

      <DialogContent>
        {loading ? (
          <Box display="flex" justifyContent="center" py={10}>
            <CircularProgress />
          </Box>
        ) : (
          <Grid container spacing={3} sx={{ pt: 2 }}>
            {/* Left Side - Profile Card */}
            <Grid item xs={12} md={4}>
              <ModernCard>
                <Box display="flex" flexDirection="column" alignItems="center" p={3}>
                  <Badge
                    overlap="circular"
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    badgeContent={
                      <Chip 
                        label={studentData?.status || 'N/A'}
                        size="small" 
                        color={studentData?.status === 'Active' ? 'success' : 'default'}
                        sx={{ 
                          color: 'white',
                          fontWeight: 600,
                          fontSize: '0.65rem'
                        }}
                      />
                    }
                  >
<Avatar
  src={studentData?.profileUrl || studentData?.profile_Url || ''}
  sx={{
    width: 120,
    height: 120,
    border: `4px solid ${deepPurple[100]}`,
    fontSize: '2rem',
    fontWeight: 700,
    background: `linear-gradient(135deg, ${deepPurple[400]}, ${teal[400]})`,
  }}
>
  {/* Initials fallback when no photo */}
  {!studentData?.profileUrl && !studentData?.profile_Url &&
    studentData?.name
      ?.split(' ')
      .map(n => n[0])
      .join('')
      .toUpperCase()
      .slice(0, 2)
  }
</Avatar>
                    />
                  </Badge>
                  <Typography variant="h6" mt={2} fontWeight={700}>
                    {studentData?.name}
                  </Typography>
                  <Typography color="text.secondary">
                    {studentData?.course}
                  </Typography>
                  <Chip
                    label={`Intake: ${studentData?.intakeId}`}
                    color="primary"
                    size="small"
                    sx={{ mt: 1 }}
                  />
                </Box>

                <Divider />

                <List>
                  <ListItem>
                    <ListItemIcon>
                      <Email color="primary" />
                    </ListItemIcon>
                    <ListItemText
                      primary="Email"
                      secondary={studentData?.email || 'N/A'}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <Phone color="primary" />
                    </ListItemIcon>
                    <ListItemText
                      primary="Phone"
                      secondary={studentData?.phone || 'N/A'}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <Fingerprint color="primary" />
                    </ListItemIcon>
                    <ListItemText
                      primary="NRIC"
                      secondary={studentData?.nric ? `••••${studentData.nric.slice(-4)}` : 'N/A'}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <CalendarToday color="primary" />
                    </ListItemIcon>
                    <ListItemText
                      primary="Enrolled"
                      secondary={formatDate(studentData?.enrolledDate)}
                    />
                  </ListItem>
                </List>
              </ModernCard>

              {/* Documents Card */}
              <ModernCard sx={{ mt: 3 }}>
                <CardHeader title="Documents" />
                <CardContent>
                  <List>
                    {studentData?.nricdoc && (
                      <ListItem>
                        <ListItemIcon>
                          <Description color="primary" />
                        </ListItemIcon>
                        <ListItemText primary="NRIC Document" />
                        <Button 
                          size="small" 
                          onClick={() => window.open(studentData.nricdoc, '_blank')}
                        >
                          View
                        </Button>
                      </ListItem>
                    )}
                    {studentData?.passportdoc && (
                      <ListItem>
                        <ListItemIcon>
                          <Description color="primary" />
                        </ListItemIcon>
                        <ListItemText primary="Passport Document" />
                        <Button 
                          size="small" 
                          onClick={() => window.open(studentData.passportdoc, '_blank')}
                        >
                          View
                        </Button>
                      </ListItem>
                    )}
                    {studentData?.educationdoc && (
                      <ListItem>
                        <ListItemIcon>
                          <Description color="primary" />
                        </ListItemIcon>
                        <ListItemText primary="Education Document" />
                        <Button 
                          size="small" 
                          onClick={() => window.open(studentData.educationdoc, '_blank')}
                        >
                          View
                        </Button>
                      </ListItem>
                    )}
                  </List>
                </CardContent>
              </ModernCard>
            </Grid>

            {/* Right Side - Details */}
            <Grid item xs={12} md={8}>
              <Tabs
                value={expandedSection}
                onChange={(e, newValue) => handleSectionChange(newValue)}
                variant="scrollable"
                scrollButtons="auto"
                sx={{ mb: 2 }}
              >
                <Tab label="Personal" value="personal" icon={<Person />} />
                <Tab label="Education" value="education" icon={<School />} />
                <Tab label="Work" value="work" icon={<Work />} />
                <Tab label="Schedule" value="schedule" icon={<Schedule />} />
                <Tab label="Financial" value="financial" icon={<Payment />} />
              </Tabs>

              {/* Personal Info Section */}
              <Collapse in={expandedSection === 'personal'}>
                <ModernCard sx={{ mb: 3 }}>
                  <CardHeader title="Personal Information" />
                  <CardContent>
                    <Grid container spacing={2}>
                      <InfoRow label="Full Name" value={studentData?.name} icon={<Person />} />
                      <InfoRow label="Gender" value={studentData?.gender} icon={<WcIcon />} />
                      <InfoRow label="Date of Birth" value={formatDate(studentData?.dob)} icon={<CalendarToday />} />
                      <InfoRow label="Citizenship" value={studentData?.citizenship} icon={<PublicIcon />} />
                      <InfoRow label="Religion" value={studentData?.religion} icon={<TempleBuddhistIcon />} />
                      <InfoRow label="Marital Status" value={studentData?.maritalStatus} icon={<HowToRegIcon />} />
                      <InfoRow label="Passport" value={studentData?.passport} icon={<AirplanemodeActiveIcon />} />
                      <InfoRow label="Passport Expiry" value={formatDate(studentData?.passportExpiryDate)} icon={<EventAvailableIcon />} />
                      <InfoRow label="SG Address" value={studentData?.currentAddress} icon={<LocationOn />} />
                      <InfoRow label="Home Address" value={studentData?.address} icon={<HomeIcon />} />
                      <InfoRow label="Postal Code" value={studentData?.postalcode} icon={<LocalPostOfficeIcon />} />
                    </Grid>
                  </CardContent>
                </ModernCard>

                {/* Emergency Contacts */}
                <ModernCard sx={{ mb: 3 }}>
                  <CardHeader title="Emergency Contacts" />
                  <CardContent>
                    {studentData?.emergencyContacts?.length > 0 ? (
                      studentData.emergencyContacts.map((contact, index) => (
                        <Box key={index} mb={2}>
                          <Typography variant="subtitle1" fontWeight="bold">
                            {contact.relationship}
                          </Typography>
                          <Grid container spacing={2}>
                            <InfoRow label="Name" value={contact.name} />
                            <InfoRow label="Phone" value={contact.number} />
                          </Grid>
                        </Box>
                      ))
                    ) : (
                      <Typography variant="body2" color="text.secondary">
                        No emergency contacts available
                      </Typography>
                    )}
                  </CardContent>
                </ModernCard>
              </Collapse>

              {/* Education Section */}
              <Collapse in={expandedSection === 'education'}>
                <ModernCard sx={{ mb: 3 }}>
                  <CardHeader title="Education History" />
                  <CardContent>
                    {studentData?.institutionDetails?.length > 0 ? (
                      studentData.institutionDetails.map((institution, index) => (
                        <Box key={index} mb={3}>
                          <Box display="flex" justifyContent="space-between" mb={1}>
                            <Typography variant="subtitle1" fontWeight="bold">
                              {institution.institution}
                            </Typography>
                            {institution.highest && (
                              <Chip label="Highest Qualification" size="small" color="primary" />
                            )}
                          </Box>
                          <Grid container spacing={2}>
                            <InfoRow label="Qualification" value={institution.qualificationsAchieved} />
                            <InfoRow label="Years" value={`${institution.fromYear} - ${institution.toYear}`} />
                            <InfoRow label="Country" value={institution.country} />
                            <InfoRow label="Language" value={institution.language} />
                          </Grid>
                        </Box>
                      ))
                    ) : (
                      <Typography variant="body2" color="text.secondary">
                        No education history available
                      </Typography>
                    )}
                  </CardContent>
                </ModernCard>
              </Collapse>

              {/* Work Experience Section */}
              <Collapse in={expandedSection === 'work'}>
                <ModernCard sx={{ mb: 3 }}>
                  <CardHeader title="Work Experience" />
                  <CardContent>
                    {studentData?.workExpirences?.length > 0 ? (
                      studentData.workExpirences.map((work, index) => (
                        <Box key={index} mb={3}>
                          <Typography variant="subtitle1" fontWeight="bold">
                            {work.name}
                          </Typography>
                          <Grid container spacing={2}>
                            <InfoRow label="Position" value={work.position} />
                            <InfoRow label="Years" value={`${work.fromYear} - ${work.toYear}`} />
                            <InfoRow label="Country" value={work.country} />
                            <InfoRow label="Nature of Position" value={work.natureOfPosition} />
                          </Grid>
                        </Box>
                      ))
                    ) : (
                      <Typography variant="body2" color="text.secondary">
                        No work experience available
                      </Typography>
                    )}
                  </CardContent>
                </ModernCard>
              </Collapse>

              {/* Schedule Section */}
              <Collapse in={expandedSection === 'schedule'}>
                <ModernCard sx={{ mb: 3 }}>
                  <CardHeader title="Module Schedule" />
                  <CardContent>
                    {studentData?.scheduleDate?.length > 0 ? (
                      <Grid container spacing={2}>
                        {studentData.scheduleDate.map((schedule, index) => {
                          const module = studentData.batch?.moduleDetails?.find(
                            m => m.id === schedule.startModulus
                          );
                          return (
                            <Grid item xs={12} sm={6} key={index}>
                              <ModernCard sx={{ p: 2 }}>
                                <Typography variant="subtitle2" fontWeight="bold">
                                  {module?.moduleName || `Module ${schedule.startModulus}`}
                                </Typography>
                                <InfoRow label="Start Date" value={formatDate(schedule.startDate)} />
                                <InfoRow label="End Date" value={formatDate(schedule.endDate)} />
                              </ModernCard>
                            </Grid>
                          );
                        })}
                      </Grid>
                    ) : (
                      <Typography variant="body2" color="text.secondary">
                        No schedule available
                      </Typography>
                    )}
                  </CardContent>
                </ModernCard>
              </Collapse>

              {/* Financial Section */}
              <Collapse in={expandedSection === 'financial'}>
                <ModernCard sx={{ mb: 3 }}>
                  <CardHeader title="Financial Information" />
                  <CardContent>
                    <Grid container spacing={2}>
                      <InfoRow label="Course Fee" value={`$${studentData?.courseFee}`} />
                      <InfoRow label="Registration Fee" value={`$${studentData?.registrationFee}`} />
                      <InfoRow label="Discount Amount" value={`$${studentData?.discountAmount || '0'}`} />
                    </Grid>

                    <Typography variant="h6" mt={3} mb={2}>
                      Installment Schedule
                    </Typography>
                    {studentData?.installmentDue?.length > 0 ? (
                      <Grid container spacing={2}>
                        {studentData.installmentDue.map((installment, index) => (
                          <Grid item xs={12} sm={6} key={index}>
                            <ModernCard sx={{ p: 2 }}>
                              <Box display="flex" justifyContent="space-between">
                                <Typography variant="subtitle2" fontWeight="bold">
                                  Installment #{installment.installmentNo}
                                </Typography>
                                <Chip label={`$${installment.amount}`} color="primary" size="small" />
                              </Box>
                              <InfoRow label="Due Date" value={formatDate(installment.dateDue)} />
                            </ModernCard>
                          </Grid>
                        ))}
                      </Grid>
                    ) : (
                      <Typography variant="body2" color="text.secondary">
                        No installment schedule available
                      </Typography>
                    )}
                  </CardContent>
                </ModernCard>
              </Collapse>
            </Grid>
          </Grid>
        )}
      </DialogContent>

      <DialogActions sx={{ p: 2, borderTop: '1px solid rgba(0,0,0,0.08)' }}>
        <SecondaryButton onClick={onClose}>
          Close
        </SecondaryButton>
        {/* <PrimaryButton>
          Save Changes
        </PrimaryButton> */}
      </DialogActions>
    </Dialog>
  );
};
export default Green;